import { jsx } from '@emotion/core'
import React, { useState, useContext, useEffect, useMemo } from 'react'
import {
  CriteriaRow,
  Title,
  FullHeightSizer,
  Content,
  // Label,
  // Filler,
} from 'core/screen-util'
import { getApiTargetInfo, getClientInfo, getValidYearRange } from 'core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { Button, DatePicker, Select, message } from 'antd'
import {
  getMarginAnalysisSummaryGroups,
  getMarginAnalysisSummaryGroupsData,
} from './api'
import R from 'ramda'
// import { CauseCodeGroupReChartPieGraph } from './component/CauseGroupRechartPie'
import { EventSummaryByCauseCode } from './component/EventSummaryByCauseCode'
import { connect } from 'react-redux'
import { EventTotals } from './component/EventTotals'
import CauseCodeBarGraph from './component/CauseCodeBarGraph'

const MarginAnalysisSummary = ({ targetInfo, CLIENT }) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const [group, setGroup] = useState([])
  const [selectedISO, setSelectedISO] = useState('')
  const [data, setData] = useState({})
  const onChange = _ => {
    setData({})
  }

  useEffect(
    _ => {
      getMarginAnalysisSummaryGroups(targetInfo)(
        selectedDateRangePicker[1]
      ).fork(setError, setGroup)
    },
    [selectedDateRangePicker, targetInfo, setError]
  )

  const groupNameList = useMemo(
    _ => {
      return R.compose(
        R.sort(d => d),
        R.uniq,
        R.map(d => d.substr(3)),
        R.map(d => d.unitGroup)
      )(group)
    },
    [group]
  )

  const onRetrieve = _ => {
    if (!selectedISO) {
      message.warn('Please, select ISO.')
      return
    }

    setSpinning(true)
    getMarginAnalysisSummaryGroupsData(targetInfo)({
      from: selectedDateRangePicker[0],
      to: selectedDateRangePicker[1],
      iso: selectedISO,
    }).fork(setError, d => {
      setSpinning(false)
      setData(d)
    })
  }
  const heightMargin = 80

  return (
    <div>
      <CriteriaRow>
        <Title>Margin Analysis Summary</Title>
        <div style={{ marginLeft: '150px' }}>ISO : </div>
        <Select
          value={selectedISO}
          onChange={iso => setSelectedISO(iso)}
          style={{
            marginRight: '5px',
            marginLeft: '5px',
            width: '200px',
          }}
        >
          {(groupNameList || []).map(d => (
            <Select.Option value={d} key={d}>
              {d}
            </Select.Option>
          ))}
        </Select>
        <DatePicker.RangePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          mode={['month', 'month']}
          // mode="decade"
          format="MMMM-YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker([d[0].startOf('d'), d[1].endOf('d')])
            onChange()
          }}
          onPanelChange={d => {
            setSelectedDateRagePicker([d[0].startOf('d'), d[1].endOf('d')])
            onChange()
          }}
        />
        <Button
          onClick={onRetrieve}
          type="primary"
          style={{ marginLeft: '50px' }}
          icon="database"
        >
          Retrieve
        </Button>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200}>
        {({ height, width }) => {
          return (
            <Content
              style={{
                height: height,
                display: 'grid',
                gridTemplateRows: height - 100 - heightMargin + 'px 100px',
                gridTemplateColumns: '1000px ' + (width - 1000) + 'px',
                gridGap: '10px',
                overflowY: 'hidden',
                overflowX: 'hidden',
                width,
              }}
            >
              <CauseCodeBarGraph
                causeCodeData={data.eventSummary}
                actualHeight={height - 180 - heightMargin}
                actualWidth={1000}
              />

              {/* <CauseCodeGroupReChartPieGraph
                actualWidth={1000}
                actualHeight={height - 120}
                // extraWidth={20}
                isEventPlanner={false}
                eventSummary={data.eventSummary || []}
                radious={20}
                outerRadius={200}
              /> */}
              <div
                style={{
                  width: 850,
                  height: height - 200,
                  // border: '1px solid black',
                  marginTop: '50px',
                }}
              >
                <EventSummaryByCauseCode
                  width={850}
                  height={height - 200}
                  CLIENT={CLIENT}
                  eventSummary={data.eventSummary || []}
                />
              </div>
              <div style={{ gridColumnEnd: 'span 2' }}>
                <EventTotals
                  width={width - 50}
                  height={70}
                  CLIENT={CLIENT}
                  totals={data.totals || []}
                />
              </div>
            </Content>
          )
        }}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  validYearRange: getValidYearRange(state),
  CLIENT: getClientInfo(state),
})
export default connect(mapStateToProps)(MarginAnalysisSummary)
